import React from "react";
import SonicBoomArticleDetail from "./SonicBoomArticleDetail";
import { useRouteMatch, useLocation, useHistory } from "react-router-dom";
import ArticleList from "components/media/board/ArticleList";
import Pagination from "components/media/board/Pagination";
import qs from "query-string";
import ArticleListItem from "components/media/board/ArticleListItem";
import SubContentTemplate from "components/common/SubContentTemplate";
import ContentTemplate from "components/common/ContentTemplate";
import PageTitleTemplate from "components/common/PageTitleTemplate";
import ArticleSearch from "components/media/board/ArticleSearch";
import { KBL_SONICBOOM_NOTICE } from "constants/page";
import Breadcrumb from "components/common/Breadcrumb";
import { getKblNotice } from "api/kbl/kbl";

const breadCrumb = {
  path: "/kbl/sonicboom/notice",
  title: "공지사항",
  type: "kblNotice",
  page: KBL_SONICBOOM_NOTICE,
};

const SonicBoomArticle = () => {
  const articleMatchSeq = useRouteMatch("/kbl/sonicboom/notice/:seq");
  const [data, setData] = React.useState([]);
  const [totalPage, setTotalPage] = React.useState(0);
  const query = qs.parse(useLocation().search);

  const location = useLocation();
  const history = useHistory();

  const articles =
    data &&
    data.map((n) => ({
      ...n,
      contents: n.artcContents && n.artcContents.replace(/<[^>]+>/g, ""),
      title: n.artcTitle,
      subTitle: n.artcSubTitle,
      seq: n.artcSq,
      registerAt: new Date(n.regDttm),
      updateAt: new Date(n.updDttm),
    }));

  const page = parseInt(location.search.split("search.page=")[1], 10) || 1;

  const goToPage = (page) => {
    const newQuery = {
      ...query,
      "search.page": page,
    };
    const toPath = `${location.pathname}?${qs.stringify(newQuery)}`;
    history.push(toPath);
  };

  const goToNextPage = () => {
    console.log("goToNextPage");
    goToPage(page + 1);
  };
  const goToPrevPage = () => {
    if (page > 1) {
      console.log("goToPrevPage");
      goToPage(page - 1);
    }
  };

  React.useEffect(() => {
    getKblNotice({ searchValue: query["search.searchWord"] ? query["search.searchWord"] : "", page: 1, limit: 2 }).then(
      (response) => {
        setTotalPage(response.data[0].no);
      }
    );
  }, [query["search.searchWord"]]);

  React.useEffect(() => {
    getKblNotice({ searchValue: query["search.searchWord"] ? query["search.searchWord"] : "", page: page, limit: 10 })
      .then((response) => {
        setData(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error fetching KBL notice:", error);
      });
  }, [page, query["search.searchWord"]]);

  return (
    <>
      <div className="kbl_mobile_notice">
        <ContentTemplate>
          <PageTitleTemplate>
            <div className="page_location" />
            {!articleMatchSeq && <ArticleSearch options={{ title: "제목" }} />}
          </PageTitleTemplate>
          <SubContentTemplate>
            {articleMatchSeq ? (
              <SonicBoomArticleDetail />
            ) : (
              <ArticleList
                articles={articles}
                itemComponent={ArticleListItem}
                type={"list"}
                className={"img_none"}
                onNextPage={goToNextPage}
                onPrevPage={goToPrevPage}
              />
            )}
          </SubContentTemplate>
        </ContentTemplate>
      </div>
      {data && data[0] && !articleMatchSeq && (
        <Pagination page={page} totalPage={Math.ceil(totalPage / 10)} onClickPage={goToPage} />
      )}
      <div style={{ padding: "0px 0px 30px 0px" }} />
    </>
  );
};

export default SonicBoomArticle;
